/** DEFINE KEY SYMBOL */

export const COOKIE_AUTH = "auth";
export const COOKIE_PATIENT = "patient";
